import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c0c4c9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pic" }
const _hoisted_3 = { class: "txt" }
const _hoisted_4 = { class: "title nowrap" }
const _hoisted_5 = { class: "attr" }
const _hoisted_6 = { class: "clicknum" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/icon/play.png" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_ctx.goods.names)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: {
				name: 'video-info',
				params: { attach: _ctx.goods.cid + '-59-0', id: _ctx.goods.id },
			}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives(_createElementVNode("img", null, null, 512), [
                [_directive_lazy, _ctx.imgUrl(_ctx.goods.names, _ctx.goods.cover)]
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.goods.names), 1),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goods.attr.split(' '), (attr, index) => {
                  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(attr), 1))
                }), 256))
              ])
            ]),
            _createElementVNode("p", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.goods.click) + "次浏览 ", 1)
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ]))
    : _createCommentVNode("", true)
}